import { z } from 'zod';

export const posDdtDocumentSerialSchema = z.object({
  kind: z.enum(['imei', 'iccid', 'macaddr', 'serial']).nullable(),
  value: z.string().min(1).max(255),
}).strict();
export type PosDdtDocumentSerial = z.infer<typeof posDdtDocumentSerialSchema>;

/** Historical values have no known kind: never consult the current catalog. */
export function resolvePosDdtDocumentSerials(
  documentSerials: readonly PosDdtDocumentSerial[] | null | undefined,
  serialNumbers: readonly string[] | null | undefined,
): PosDdtDocumentSerial[] {
  return documentSerials?.map((serial) => ({ ...serial }))
    ?? (serialNumbers ?? []).map((value) => ({ kind: null, value }));
}